import React, {useContext, useState, useEffect, useRef, useLayoutEffect} from 'react';
import {inject, observer} from 'mobx-react';
import { Transition } from 'react-transition-group';
import {brandContext} from "../../../store/brandContext";
import {APP_PREFIX} from "../../../config";
import {BRANDS} from "../../../common";


//TODO описать компонент (Эрик)
const PreLoader = inject('appStore')(observer(props => {
  const brandName = useContext(brandContext);
  const [count, setCount] = useState(1)
  const loaderSrc = `${APP_PREFIX}/img/loaders/preloader_${brandName}.gif`;
  const background = brandName === BRANDS.cupis ? '#00234b' : '#27587b'
  const duration = 300;

  const list = [1, 2, 3, 6, 34, 7, -1];

  useEffect(()=>{
    let i = 0;
    setInterval(() => {
      if (i === 6) {
        i = 0
      }
      setCount(list[i])
      i--
      
    }, 1500)
  },[])

  return (
    <div className='page-layout'>
      <div
        id='___loader'
        className='Preloader'
        key='loader'
        style={{
          backgroundColor: background,
          position: 'absolute',
          height: '100vh',
          width: '100vw',
          zIndex: 99999999,
        }}
      >
        {brandName === BRANDS.cupis ?
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'transition(-50%, -50%)',
          }}
           className="splash__screen-icon">
            <Transition
              in={true}
              timeout={500}
              >
              {state => (
                <div className={`icon ${state}`}>
                  <i rel="preload" className={`f-s-ico-${count}`} />
                </div>
              )}
            </Transition>
          </div>
          :
          <img
            src={loaderSrc}
            alt='Loading'
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              opacity: '.3',
              width: '160px',
            }}
          />
        }
      </div>
    </div>
  );

}));

export default PreLoader;

// import React, { Component } from 'react';
// import { gsap } from 'gsap';
//
// export default class Index extends Component {
//   list = [1, 2, 3, 6, 34, 7, -1];
//   state = {
//     index: 0,
//     status: this.props.status,
//     realState: this.props.status,
//   };
//
//   iconRef = React.createRef();
//   tweenMax;
//
//   componentDidMount() {
//     this.startPulse();
//   }
//
//   componentWillUnmount() {
//     this.tweenMax.kill();
//   }
//
//   startPulse = () => {
//     let counter = 0;
//     this.tweenMax = gsap.to(this.iconRef.current, 0.5, {
//       fontSize: 80,
//       rotation: 45,
//       repeat: -1,
//       yoyo: true,
//       onRepeat: () => {
//         ++counter % 2 == 0 && this.nextIcon();
//       },
//     });
//   };
//
//   nextIcon = () => {
//     let index = this.list.indexOf(this.list[this.state.index]);
//     if (index == this.list.length - 1) {
//       index = 0;
//     } else {
//       index++;
//     }
//     this.setState({
//       index,
//     });
//   };
//
//   render() {
//     return (
//       <div className="splash__screen">
//         <div className="splash__screen-loader">
//           <div ref={this.iconRef} className="splash__screen-icon"
//                style={{
//             position: 'absolute',
//             top: '50%',
//             left: '50%',
//             transform: 'transition(-50%, -50%)',
//           }}>
//             <i className={`f-s-ico-${this.list[this.state.index]}`} />
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

